module.exports = __webpack_public_path__ + "img/124.7bf10f3d.jpg";